module.exports = __webpack_public_path__ + "static/parade-2020-house60-98cc170f7e95929416514973b624e1f1.jpg";